import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation } from "@/mixins/index";
import Events from "./mixins/Events";
import { eventRetain } from "@/api/dataAll/retentionAnalysis";
import { advertiserList } from "@/api/Administration/advertiser";
import { customEventAdd, customEventList, customEventDel } from "@/api/customizationEvents/customizationEvents";
import updEvents from "./components/updEvents.vue";
import timeFunnel from "./timeFunnel";
export default {
  name: "customizationEvents",
  components: {
    updEvents: updEvents,
    timeFunnel: timeFunnel
  },
  mixins: [serchSelect, tabulation, Events],
  data: function data() {
    return {
      activeIndex: 'customizationMg',
      // more:true,
      value2: [],
      searchData: {
        begin_date: '',
        end_date: '',
        country: '',
        begin_action: '',
        retain_action: '',
        retain_days: 5,
        analyze_type: 'device',
        ad_id: ''
      },
      behaviorList: [],
      rehaviorList: [],
      // 事件表字段
      formTow: {
        event_name: "",
        event: ""
      },
      tableDataTow: []
    };
  },
  created: function created() {
    this.getcustomEventList();
  },
  activated: function activated() {},
  methods: {
    /**
     * 
     *  自定义事件表相关
     * */
    getcustomEventList: function getcustomEventList() {
      var _this = this;

      customEventList({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this.tableDataTow = res.data;
          _this.behaviorList = [];
          _this.rehaviorList = [];
          res.data.forEach(function (i) {
            var data = {
              label: i.event_name,
              value: i.event,
              disabled: false
            };

            _this.behaviorList.push(_objectSpread({}, data));

            _this.rehaviorList.push(_objectSpread({}, data));
          });
          _this.searchData.begin_action = res.data[0] ? res.data[0].event : '';
          _this.searchData.retain_action = res.data[1] ? res.data[1].event : res.data[0] ? res.data[0].event : '';
        }
      });
    },
    addtableDataTow: function addtableDataTow() {
      var _this2 = this;

      if (!this.formTow.event_name || !this.formTow.event) {
        this.$message.error(this.$t('pleaseCompleteInput'));
        return;
      }

      var data = _objectSpread(_objectSpread({}, this.formTow), {}, {
        game_id: this.rawData.game_id
      });

      customEventAdd(data).then(function (res) {
        if (res.status == 200) {
          _this2.$message.success(_this2.$t('addSuccess'));

          _this2.getcustomEventList();

          _this2.formTow.event_name = '';
          _this2.formTow.event = '';
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                customEventDel({
                  id: id,
                  game_id: _this3.rawData.game_id
                }).then(function (res) {
                  _this3.getcustomEventList();
                });

                _this3.$message({
                  type: "success",
                  message: _this3.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handover: function handover(e) {
      this.activeIndex = e;
    }
  }
};